import { ChevronDown, Lightbulb, Info } from 'lucide-react';
import { IndicateurGuide } from './IndicateurGuide';
import { idsDe } from './constantes';

const Avancement = ({ c, progression }) => {
  const { pret, total } = progression.compte(idsDe([c]));
  return (
    <span className={`shrink-0 rounded-full px-2.5 py-1 text-xs font-bold ${pret === total ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-100 text-slate-500'}`} data-testid={`guide-critere-avancement-${c.cle}`}>
      {pret}/{total} prêts
    </span>
  );
};

export const CritereGuide = ({ c, teinte, ouvert, onBasculer, progression }) => (
  <section id={`critere-${c.cle}`} className="scroll-mt-24 overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm" data-testid={`guide-critere-${c.cle}`}>
    <button type="button" onClick={onBasculer} aria-expanded={ouvert} data-testid={`guide-critere-toggle-${c.cle}`}
      className="flex w-full items-center gap-3 bg-[#0F172A] p-3 text-left text-white transition-colors hover:bg-[#1E293B] sm:gap-4 sm:p-4">
      <span className={`shrink-0 rounded-xl px-3 py-2 text-sm font-bold sm:text-base ${teinte.fort}`}>{c.code}</span>
      <span className="min-w-0 flex-1">
        <span className="block font-semibold sm:text-lg">{c.court}</span>
        <span className={`mt-0.5 block text-xs ${c.minimum ? 'font-semibold text-amber-300' : 'text-white/50'}`}>
          {c.minimum ? `Minimum fixé par l'arrêté : ${c.minimum}` : 'Tous les indicateurs sont attendus'}
        </span>
      </span>
      <span className={`hidden shrink-0 rounded-lg px-3 py-1.5 text-[11px] font-bold uppercase tracking-wide md:inline ${teinte.fort}`}>Concerne : {c.concerne}</span>
      <Avancement c={c} progression={progression} />
      <ChevronDown className={`h-5 w-5 shrink-0 transition-transform duration-300 ${ouvert ? 'rotate-180' : ''}`} />
    </button>
    {ouvert && (
      <div className="space-y-4 p-4 sm:p-6" data-testid={`guide-critere-contenu-${c.cle}`}>
        <div className="rounded-xl bg-slate-50 p-4 text-sm">
          <p className="italic text-slate-500"><span className="font-semibold not-italic text-slate-600">Compétence (texte officiel) : </span>{c.intitule}</p>
          <p className="mt-2 font-semibold text-[#0F172A]">Critère : {c.critere}</p>
          {c.note && <p className="mt-2 flex gap-2 text-xs font-semibold text-amber-700" data-testid={`guide-critere-note-${c.cle}`}><Info className="h-4 w-4 shrink-0" />{c.note}</p>}
        </div>
        {c.indicateurs.map((i, k) => <IndicateurGuide key={i.id} i={i} k={k + 1} teinte={teinte} progression={progression} />)}
        {c.astuce && (
          <p className={`flex items-start gap-2 rounded-xl p-3.5 text-sm font-semibold ${teinte.clair} ${teinte.texte}`} data-testid={`guide-astuce-${c.cle}`}>
            <Lightbulb className="mt-0.5 h-4 w-4 shrink-0" /> Astuce : {c.astuce}
          </p>
        )}
      </div>
    )}
  </section>
);
